import { createContext } from 'react';
import type { ScenarioPhotoPhase } from '@components/ScenarioPhotoLightbox';
import type { ScenarioView } from '@hopdrive/feature-order-index';

export interface ScenarioOrderHandlers {
  onAssignDriver: () => void;
  onOpenMove: (moveId: number) => void;
  onOpenChat: () => void;
  onCreateDuplicate: () => void;
  onCreateInverse: () => void;
  onChangePromiseTime: () => void;
  onCancelOrder: () => void;
}

/**
 * What a scenario surface can do with an order.
 *
 * The context and its type sit apart from the provider that fills them so the provider
 * file exports components and nothing else — which is what keeps fast refresh working on
 * the file most likely to be edited while a surface is open.
 */
export interface ScenarioActionsContextValue {
  openLegPhotos: (moveId: number, phase: ScenarioPhotoPhase) => void;
  buildCardActions: (view: ScenarioView) => ScenarioOrderHandlers;
  /**
   * Orders whose assign/unassign is in flight — the modal succeeded but the data has
   * not caught up. One id covers the whole order: the pill is order-level, so no
   * surface tracks per-move assigning state.
   */
  assigningScenarioIds: ReadonlySet<number>;
}

/** Null by default: a surface with no provider renders actionless rather than throwing. */
export const ScenarioActionsContext = createContext<ScenarioActionsContextValue | null>(null);
